import { getHandler } from "utils/handler";
import { initI18n } from "utils/i18n";
window.startup = (app) => {
  let entryPoint = app.entryPoint;
  if (!entryPoint) {
    entryPoint = location.pathname.toLowerCase();
    if (entryPoint[entryPoint.length - 1] == "/") {
      entryPoint = entryPoint.slice(0, -1);
    }
    if (!getHandler(entryPoint)) {
      entryPoint = entryPoint + "/index";
    }
  }
  const handler = getHandler(entryPoint);
  if (!handler) return;

  import(
    /* webpackChunkName: "locale_[request]" */ `locale/${app.locale}`
  ).then((messages) => {
    initI18n(app.locale, messages.default, app.localizer);
    handler(app);
  });
};
